import { useEffect } from 'react';
import { ModelType } from '@packages/global';
import { useModelStore } from '../stores/modelStore';

export function useModels(type?: ModelType) {
  const { models: allModels, loading, fetchModels, getModelsByType } = useModelStore();

  useEffect(() => {
    fetchModels();
  }, [fetchModels]);

  const models = type ? getModelsByType(type) : allModels;

  return { models, loading };
}
